import React from "react"
import { Link } from "gatsby"

const MainNav = ({ routeParams }) => (
  <div className="main-nav-container flex flex-wrap w-full justify-center xl:justify-end pt-2">
    <div className="link tracking-[2px]">
      <Link to={`/${routeParams?.location}/ceremony/wedding-ceremony-music/`}>
        CEREMONY MUSIC
      </Link>
    </div>
    <div className="link tracking-[2px]">
      <Link to={`/${routeParams?.location}/reception/wedding-reception-music/`}>
        RECEPTION MUSIC
      </Link>
    </div>
    <div className="link tracking-[2px]">
      <Link to={`/${routeParams?.location}/wedding-music-packages/`}>
        MUSIC PACKAGES
      </Link>
    </div>
    <div className="link tracking-[2px]">
      <Link to={`/${routeParams?.location}/wedding-music-videos/`}>
        MUSIC INSPIRATION
      </Link>
    </div>
    <div className="link tracking-[2px]">
      <Link to={`/quote/`}>
        <div className="inline-block btn btn--primary qbutton">GET A QUOTE</div>
      </Link>
    </div>
  </div>
)

export default MainNav
